module.exports = __webpack_public_path__ + "img/71.8.TSS.65159bc2.png";